module.exports = __webpack_public_path__ + "static/img/icon_js_eventmsg.2a6abe9f.png";